import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setFieldValue from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SetFieldValue";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ContactFormContext } from "@insite/content-library/Widgets/ContactUs/ContactForm";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";


const enum fields {
    label = "label",
    hintText = "hintText",
    isRequired = "isRequired",
    maininput = "maininput",
    errorMessage="errorMessage"
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.label]: string;
        [fields.hintText]: string;
        [fields.isRequired]: boolean;
        [fields.maininput]: string;
        [fields.errorMessage]:string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    companyName: state.components.contactUsForm.fieldValues["companyName"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface CompanyNameStyles {
    companyNameTextField?: TextFieldPresentationProps;
    maininput?: InjectableCss;
    errorMessage?:InjectableCss;
}

export const companyNameStyles: CompanyNameStyles = {
    maininput: {
        css: css`
             ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    css`
                     [class^="FormFieldStyle"]{
                     display: inline;
            }  
                `,
                ])} 
        `
    },
    companyNameTextField: {
        css: css`
          ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    css`
                     width: 55% !important;
                     float: right;
                `,
                ])} 
       
        `,
        labelProps: {
            css: css`
               ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        null,
                        null,
                        css`
                     width: 40% !important;
                     float: left;
                     margin-top: 5px;
                `,
                    ])} 
            `
        },
    },
    errorMessage:{
        css:css`
        line-height: 1.5em;
          font-weight: 600;
          background: #fff;
          color: #c60f13;
          display: block;
          clear: both;
          font-size: 14px;
          position: relative;
          top: 10px;
          background: transparent;
  `,
    }
}
const styles = companyNameStyles;

const CompanyName: React.FC<Props> = ({ fields, companyName, setFieldValue }) => {
    const { label, hintText, isRequired } = fields;
    const contactFormContext = React.useContext(ContactFormContext);
    const [companyNameErrorMessage, setCompanyNameErrorMessage] = React.useState("");

    React.useEffect(() => {
        contactFormContext.validators.companyName = validateCompanyName;
        if (typeof companyName !== "undefined") {
            validateCompanyName();
        }
    }, [companyName]);

    React.useEffect(() => {
        contactFormContext.validators.companyName = validateCompanyName;
    }, [isRequired]);

    const validateCompanyName = () => {
        const errorMessage = isRequired && !companyName ? (siteMessage("Field_Required", label) as string) : "";
        setCompanyNameErrorMessage(errorMessage);
        return !errorMessage;
    };

    const companyNameChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFieldValue({ key: "companyName", value: event.target.value });
    };

    return (
        <>
            <StyledWrapper {...styles.maininput}>
                <TextField
                    {...styles.companyNameTextField}
                    label={label}
                    required={isRequired}
                    // placeholder={hintText}
                    value={companyName || ""}
                    // error={companyNameErrorMessage}
                    onChange={companyNameChangeHandler}
                />
            <Typography {...styles.errorMessage}>{companyNameErrorMessage}</Typography>

            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CompanyName),
    definition: {
        group: "Contact Us",
        icon: "input-pipe",
        fieldDefinitions: [
            {
                name: fields.label,
                displayName: "Label",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Company",
                isRequired: true,
            },
            {
                name: fields.hintText,
                displayName: "Hint Text",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "",
                isRequired: false,
            },
            {
                name: fields.isRequired,
                displayName: "Required Field",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
